<div class="market-history">
  <h2 class="heading">
    {{ "market-trades" | translate }}

    <i *ngIf="isFrozen" class="fa-regular fa-circle-play play" (click)="toggleFrozen()" matTooltipPosition="left"
    matTooltip="{{ 'start' | translate }}"></i>
  <i *ngIf="!isFrozen" class="fa-regular fa-circle-pause pause ms-2" (click)="toggleFrozen()"
    matTooltipPosition="left" matTooltip="{{ 'stop' | translate }}"> </i>
    <button  matTooltipPosition="left" class="p-0 m-0" matTooltip="{{ 'export-excel' | translate }}"
   (click)="exportAsExcel()" mat-icon-button color="primary">
   <mat-icon class="action-button">save_alt</mat-icon>
 </button>
  </h2>
  <div id="recent-trades" *ngIf="isMarket">
    <table #TABLE class="table">
      <thead>
        <tr style="padding-inline-end: 10px;">
          <th style="min-width:30% !important;max-width: 30% !important;">{{"time"|translate}}</th>
          <th style="min-width: 78px !important; max-width: 78px !important;">{{"symbol"|translate}}</th>
          <th style="min-width: 78px; max-width: 78px;">{{"price"|translate}}</th>
          <th style="min-width: 78px; max-width: 78px;">{{"qty"|translate}}</th>
          <th style="min-width: 78px; max-width: 78px;">{{"change"|translate}}</th>
        </tr>
      </thead>
      <tbody *ngIf="!companyTrades">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> {{"select-company-hint"|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody *ngIf="companyTrades!=null && companyTrades.length == 0">
        <div class="row no-data m-0">
          <div class="col-md-12">
            <img class="empty-state" src="/assets/img/noData.png" />
            <div class="col-sm-12">
              <h6> {{'no-trades'|translate}} </h6>
            </div>
          </div>
        </div>
      </tbody>
      <tbody class="d-flex justify-content-center" *ngIf="isTradesLoading">
        <div class="spinner-border  text-secondary m-5" role="status">
          <span class="sr-only"></span>
        </div>
      </tbody>
      <tbody *ngIf="companyTrades != null && companyTrades?.length>0">
        <tr *ngFor="let item of companyTrades">
          <td style="padding-inline-end: 0px !important;font-size: 12px; min-width:30% !important;max-width: 30% !important;">
            <span *ngIf="item.EXEC_TIME != null" style="white-space: nowrap">{{item.EXEC_TIME | date:'h:mm:ss'}}</span>
          </td>
          <td style="padding-inline: 5px !important; min-width:78px !important; vertical-align: middle; max-width: 78px !important; font-size: 12px; text-overflow:ellipsis !important;white-space: nowrap;overflow: hidden;">
            {{(translate.currentLang=='en')?item.ENG_Name:item.ARB_Name}}
          </td>
          <td style="min-width: 78px; max-width: 78px;">
            {{item.TRADE_PRICE}}
          </td>
          <td style="min-width: 78px; max-width: 78px;">
            {{item.TRADE_VOLUME | number: "1.0":"en-US"}}
          </td>
          <td style="min-width: 78px; max-width: 78px;" [ngClass]="item.CHANGE_PRC>0? 'green' : (item.CHANGE_PRC < 0)? 'red':''">
            {{item.CHANGE_PRC}} <span>%</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <app-not-full-market *ngIf="!isMarket"></app-not-full-market>
</div>
